<!-- Merge wireframe cockpit with fully rendered cockpit -->

<template>
    <div>
        <p>About VR</p>
        <div class="video">
      <video id="vr-video" :height="getWindowHeight()" :width="getWindowWidth()" @click="changeVideo()" autoplay muted>
        <source src="../assets/vr-environment_1_1.mp4">
      </video>
        </div>
    </div>
</template>

<script>
var video = document.getElementById("vr-video");
export default {
    name: "VR",
    methods: {
        getWindowHeight() {
            return window.innerHeight-65;
        },
        getWindowWidth() {
            return window.innerWidth;
        },
        changeVideo() {
            if(video.src == '<source src="../assets/vr-environment-p1.mp4">'){
                this.src = '<source src="../assets/vr-environment-p2.mp4">'
            } else {
                this.src = '<source src="../assets/vr-environment-p1.mp4">'
            }
        }
    },
    data() {
        return {
            src: '<source src="../assets/vr-environment-p1.mp4" type="video/mp4">'
        }
    }
}
</script>

<style scoped>
.main{
    margin-top: 0px;
}
.video{
    margin-top: 0px;
}
</style>